//@flow

import type {Action} from '../actions/actions';
import * as actions from '../actions/actions';
import type {VideoList} from '../store';

const defaultVideos = {
  season: null,
  fullLengthVideos: [],
  fetchingVideoList: false,
  fetchedVideoList: false,
  error: null,
};

let initialVideoData = defaultVideos;

export default function videos(state: VideoList = initialVideoData, action: Action): VideoList {

  switch (action.type) {

    case actions.FETCHING_VIDEO_LIST:
      return Object.assign(
        {},
        state, {fetchingVideoList: true, fetchedVideoList: false, error: null}
      );

    case actions.FETCHING_VIDEO_LIST_ERROR:
      return Object.assign(
        {},
        state, {fetchingVideoList: false, fetchedVideoList: false, error: action.payload}
      );

    case actions.RECEIVED_VIDEO_LIST:
      return Object.assign(
        {},
        action.payload,
        {
          fetchedVideoList: true,
          fetchingVideoList: false
        }
      );

    case actions.CHANGE_SEASON:
      return Object.assign(
        {},
        state,
        {season: action.payload}
      );

    case actions.CLICK_CHANGE_SPECIAL:
      return state;

    case actions.CLICK_SHOW_ALL_AIRDATES:
      return state;

    default:
      return state;
  }

};
